<template>
    <div class="form form--edit-account">
        <form @submit.prevent="submitAccount">
            <CoreUpload
                url="admin.users.upload-media"
                :src="'users/images'"
                :payload="[]"
                mode="image"
                ratio="1-1"
                round
                inline
                label="Profielfoto"
                size="small"
                v-model="userForm.image"
            />
            <!-- Profile picture -->

            <CoreInput
                class="mt-2"
                v-model="userForm.name"
                :errors="$page.errors.name"
                :staticLabel="true"
                autocomplete="name"
                label="Volledige naam"
            />
            <CoreInput
                class="mt-1"
                v-model="userForm.email"
                :errors="$page.errors.email"
                :staticLabel="true"
                autocomplete="email"
                label="E-mailadres"
                type="email"
            />

            <div class="button-wrapper mt-2">
                <CoreButton
                    :disabled="sending"
                    :loading="sending"
                    data-theme="primary"
                    @click="submitAccount()"><span>Wijzigingen opslaan</span></CoreButton>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: 'EditAccount',
        data() {
            return {
             sending: false,
             userForm: {
                    name: this.$page.auth.user.name,
                    email: this.$page.auth.user.email,
                    image: this.$page.auth.user.image
                }
            }
        },

        methods: {
            submitAccount() {
                this.sending = true

                const route = this.route('account.update');

                this.$inertia.put(route, this.userForm)
                    .then(() => {
                        if (!Object.keys(this.$page.errors).length) {
                            this.$bvModal.hide('profile-settings')
                        }
                        this.sending = false
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
